export default __webpack_public_path__ + "static/media/interactive.fc064d25.svg";